import { render, staticRenderFns } from "./UserApplicationForDormitory.vue?vue&type=template&id=660fb672&"
import script from "./UserApplicationForDormitory.vue?vue&type=script&lang=js&"
export * from "./UserApplicationForDormitory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports